// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y10xudGEwBgo99qYG1DA{padding:0 24px 14px}.pwCOaTvNvobi3nh2zKs0{justify-content:flex-end;gap:8px;padding:16px 24px 24px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `y10xudGEwBgo99qYG1DA`,
	"footer": `pwCOaTvNvobi3nh2zKs0`
};
export default ___CSS_LOADER_EXPORT___;
